import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=07aa26a4&"
import script from "./CButton.vue?vue&type=script&lang=js&"
export * from "./CButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07aa26a4')) {
      api.createRecord('07aa26a4', component.options)
    } else {
      api.reload('07aa26a4', component.options)
    }
    module.hot.accept("./CButton.vue?vue&type=template&id=07aa26a4&", function () {
      api.rerender('07aa26a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/common/CButton.vue"
export default component.exports